//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"DrawingType",1,0],[0,"FormingVelocity",1,0],[0,"HoldingVelocity",1,0],[0,"ProcessReferSide",1,0],[0,"ProcessType",1,0],[0,"SpecialFrameDis",1,0],[0,"Springback",1,0],[0,"SteelGap",1,0],[0,"ToolGap",1,0]],[[["order","station"],"CreateAProcessSimulationTemplate",{R_:{udoTag:"NXObject"}},2,0],[["option"],"EditDefinedProcessEntity",{},1,0],[["specialFrames"],"AddSpecialFrame",{},1,0]],[]];
SPLM.Tooling.FormabilitySimProcessConfigBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FormabilitySimProcessConfigBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FormabilitySimProcessConfigBuilder.ReferSide = Object.freeze({
    "PunchSide" : "PunchSide", "DieSide" : "DieSide", "NoOffset" : "NoOffset"});

SPLM.Tooling.FormabilitySimProcessConfigBuilder.ProcessTypes = Object.freeze({
    "Flanging" : "Flanging", "Drawing" : "Drawing", "Trimming" : "Trimming", "IdleStation" : "IdleStation", "Piercing" : "Piercing", "Springback" : "Springback"});

SPLM.Tooling.FormabilitySimProcessConfigBuilder.DrawingPressType = Object.freeze({
    "Up" : "Up", "Down" : "Down"});

SPLM.Tooling.FormabilitySimProcessConfigBuilder.ProcessEdit = Object.freeze({
    "Delete" : "Delete", "Update" : "Update", "Suppress" : "Suppress"});

export default SPLM;